/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

import styles from "./Dashboard.module.scss";

import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import BarChart from "../../components/BarChart";
import BarChartStacked from "../../components/BarChartStacked";
import Calendar from "../../components/Calendar";
import DashboardMetrics from "../../components/DashboardMetrics";
import GetCoaches from "../../components/GetCoaches/";
import Grid from "../../components/Grid";
import RadialChart from "../../components/RadialChart";
import { apiRequest } from "../../utils/api";
import { getLocalValue } from "../../utils/auth";

// Team's Dashboard HTML Structure
const TeamDashboard = ({ userId, ...props }) => {
  const { t } = useTranslation();
  const coach_id = userId ? userId : getLocalValue("uid");
  const [filterValue, setFilterValue] = useState(["monthly"]);
  const [compareValue, setCompareValue] = useState(coach_id);
  const filterBy = ["monthly", "quarterly", "yearly"];
  const [metricsValue, setMetricsValue] = useState(null);
  const [sessionTypeMetrics, setSessionTypeMetrics] = useState(null);
  const [barChartStackedData, setBarChartStackedData] = useState(null);
  const [coachList, setCoachList] = useState(null);
  const [teamsMetrics, setTeamsMetrics] = useState(null);
  const [showNotification, setShowNotification] = useState(false);
  const [ops, setOps] = useState("OP-"); // Default to '1' (Operations Only)
  const [reporting, setReporting] = useState(0); // Default to '1' (Operations Only)

  const history = useHistory();

  const handleChange = event => {
    setFilterValue(event.target.value);
  };

  const getTeamDashboardMetrics = () => {
    apiRequest
      .get(
        `/api/getTeamDashboardMetrics?coach_id=${compareValue}&compare=${compareValue === coach_id ? "team" : "coach"
        }&filter=${filterValue}&type=${ops}&report=${reporting}`
      )
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data;
          setMetricsValue(data);
        }
      })
      .catch(error => { });
  };

  const getTeamSessionDuration = () => {
    apiRequest
      .get(
        `/api/getTeamSessionDuration?coach_id=${coach_id}&filter=${filterValue}&type=${ops}&report=${reporting}`
      )
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data;
          setBarChartStackedData(data);
        }
      })
      .catch(error => { });
  };

  const getSessionTypeMetrics = () => {
    apiRequest
      .get(
        `/api/getSessionTypeMetrics?coach_id=${compareValue}&compare=${compareValue === coach_id ? "team" : "coach"
        }&filter=${filterValue}&type=${ops}&report=${reporting}`
      )
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data;
          setSessionTypeMetrics(data);
        }
      })
      .catch(error => { });
  };
  const getTeamCoachedSessionMatrics = () => {
    apiRequest
      .get(`/api/getTeamCoachedSessionMatrics?uid=${coach_id}&type=${ops}&report=${reporting}`)
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data;
          setTeamsMetrics(data);
        }
      })
      .catch(error => { });
  };

  const getCoachName = coachId => {
    if (coachList) {
      const selectedObj = coachList.filter(item => item.uid === coachId);
      return selectedObj.length
        ? selectedObj[0].u_fullname
        : t("dashboard.coach.teamAverage");
    } else {
      return t("dashboard.coach.teamAverage");
    }
  };
  useEffect(() => {
    const checkNotification = async () => {
      const currentDate = new Date();
      const currentDay = currentDate.getDate();
      const isFirstLogin = localStorage.getItem("firstLogin") === null;
      console.log(localStorage, "login");

      // Check if it's the 15th of the month and if it's the coach's first login after seeing the notification
      if (currentDay === 8 && isFirstLogin) {
        setShowNotification(true);
      } else {
        // Check if the notification should be automatically dismissed
        const firstLoginTimestamp = localStorage.getItem("firstLogin");
        if (firstLoginTimestamp) {
          const nextDayTimestamp = new Date(
            parseInt(firstLoginTimestamp, 10) + 24 * 60 * 60 * 1000
          ).getTime();
          if (currentDate.getTime() >= nextDayTimestamp) {
            setShowNotification(false);
          }
        }
      }
    };

    checkNotification();
  }, []);

  const handleDismiss = () => {
    // Dismiss the notification
    setShowNotification(false);
  };

  const handleCreateSession = () => {
    // Redirect to the "Create session" page
    // Add your redirection logic here
    history.push("/sessions/form/new");
  };

  const handleCompareValueChange = event => {
    const value = event.target.value; // Get the numeric value (1 or 2)
    setOps(value);
  };

  const handleReportingValueChange = event => {
    const value = event.target.value; // Get the numeric value (1 or 2)
    setReporting(value);
  };
  useEffect(() => {
    // get Team Dashboard Calendar details
    getTeamDashboardMetrics();
    getSessionTypeMetrics();
    getTeamSessionDuration();
    getTeamCoachedSessionMatrics();
  }, [filterValue, compareValue, ops, reporting]);

  return (
    <div className={styles.detailsContainer}>
      <div
        className={styles.row}
        style={{ borderBottom: "none", marginBottom: 0 }}
      >
        <Calendar userId={coach_id} type={ops} report={reporting} />
      </div>
      <div className={styles.rows}>
        <div className={styles.deptSection}>
          <h4 className={`${styles.sectionHeadlist}`}>
            {t("dashboard.coach.department")}
          </h4>
          <div style={{ display: "inline-block" }}>
            <Select
              className={styles.formSelect}
              searchable={true}
              value={ops}
              onChange={handleCompareValueChange}
            >
              <MenuItem key={"OP-"} value="OP-">
                Operations Only
              </MenuItem>
              <MenuItem key={"ALL-OP"} value="ALL">
                Operations & Non-Operations
              </MenuItem>
            </Select>
          </div>
        </div>
        <div className={styles.deptSection}>
          <h4 className={`${styles.sectionHeadlist}`}>
            {t("dashboard.coach.reportingLine")}
          </h4>
          <div style={{ display: "inline-block" }}>
            <Select
              className={styles.formSelect}
              searchable={true}
              value={reporting}
              onChange={handleReportingValueChange}
            >
              <MenuItem key={0} value="0">
                Direct reporting
              </MenuItem>
              <MenuItem key={1} value="1">
                Direct reporting & Manually Tagged
              </MenuItem>
            </Select>
          </div>
        </div>
      </div>
      <div className={styles.row}>
        <h4 className={`${styles.sectionHead} ${styles.bold}`}>
          {t("dashboard.coach.metricsHead")}
        </h4>
        {teamsMetrics && <DashboardMetrics data={teamsMetrics} />}
      </div>

      <div className={styles.row}>
        <h4 className={`${styles.sectionHead}`}>
          {t("dashboard.coach.showResultFor")}
          <Select
            className={styles.sectionFilter}
            value={filterValue}
            onChange={handleChange}
            input={<Input />}
            IconComponent={ExpandMoreIcon}
          >
            {filterBy.map(filter => (
              <MenuItem key={filter} value={filter}>
                {filter}
              </MenuItem>
            ))}
          </Select>
        </h4>
        <Grid>
          <RadialChart
            theme={"#D55757"}
            percentage="80"
            title={t("dashboard.coach.happiness")}
            label={`${t(
              "dashboard.coach.ratedSession"
            )} <span>({{chartValue}})</span> / Unrated session <span>({{secondParam}})</span> / ${t(
              "dashboard.coach.totalSession"
            )} <span>({{totalValue}})</span>`}
            frequency={filterValue}
            api={`getTeamHappinessDetails?coach_id=${coach_id}&filter=${filterValue}&type=${ops}&report=${reporting}`}
            average="average_rated_sessions"
            totalValue="total_sessions"
            secondParam="total_unrated_sessions"
            chartValue="total_rated_sessions"
          />
          <RadialChart
            theme={"#FF9C12"}
            title={t("dashboard.coach.complimentLikes")}
            label={`${t(
              "dashboard.coach.likes"
            )} <span>({{chartValue}})</span> / ${t(
              "dashboard.coach.totalComplements"
            )} <span>({{totalValue}})</span>`}
            frequency={filterValue}
            api={`getTeamComplimentDetails?coach_id=${coach_id}&filter=${filterValue}&type=${ops}&report=${reporting}`}
            average="average_liked_compliments"
            totalValue="total_compliments"
            chartValue="total_liked_compliments"
          />
          <RadialChart
            theme={"#13C77A"}
            percentage="73"
            title={t("dashboard.coach.success")}
            label={`${t(
              "dashboard.coach.passRate"
            )} <span>({{chartValue}})</span> / ${t(
              "dashboard.coach.totalSubjects"
            )} <span>({{totalValue}})</span>`}
            frequency={filterValue}
            api={`getTeamSuccessDetails?coach_id=${coach_id}&filter=${filterValue}&type=${ops}&report=${reporting}`}
            responseKey=""
            average="average_success"
            totalValue="total_coached_subject"
            chartValue="total_passed_subject"
          />
          <RadialChart
            theme={"#13C77A"}
            percentage="73"
            title={t("dashboard.personal.kpisuccess")}
            label={`${t(
              "dashboard.personal.passRate"
            )} <span>({{chartValue}})</span> / ${t(
              "dashboard.personal.totalSubjects"
            )} <span>({{totalValue}})</span>`}
            frequency={filterValue}
            api={`getTeamSuccessDetails?coach_id=${coach_id}&filter=${filterValue}&type=${ops}&report=${reporting}`}
            responseKey=""
            average="average_target_kpi_success"
            totalValue="totalKpiSubjects"
            chartValue="kpi_success_rate"
          />
        </Grid>
      </div>
      <div className={styles.row}>
        <h4 className={`${styles.sectionHead}`}>
          {t("dashboard.coach.comparedTo")}
          <GetCoaches
            style="inline-block"
            userId={userId}
            className={styles.comparingFilter}
            defaultItem={{
              value: coach_id,
              label: t("dashboard.coach.teamAverage"),
            }}
            value={compareValue}
            getCoachList={coachLists => {
              setCoachList(coachLists);
            }}
            handleChange={val => {
              setCompareValue(val);
            }}
          />
        </h4>
        {metricsValue ? (
          <Grid>
            <BarChart
              title={t("dashboard.coach.mostCoachedSubjects")}
              colors={["#13C77A", "#8FDEB2"]}
              fontColors={["#212121", "#212121"]}
              legends={[
                t("dashboard.coach.individual"),
                getCoachName(compareValue),
              ]}
              maxValue={metricsValue.max_value}
              data={metricsValue.most_coached_subjects}
            />
            <BarChart
              title={t("dashboard.coach.mostFailedSubjects")}
              colors={["#C73426", "#E99A95"]}
              fontColors={["#212121", "#212121"]}
              legends={[
                t("dashboard.coach.individual"),
                getCoachName(compareValue),
              ]}
              maxValue={metricsValue.max_value}
              data={metricsValue.most_failed_subjects}
            />
            <BarChart
              title={t("dashboard.coach.topSkillsToImprove")}
              colors={["#2B7EFB", "#C5DAFA"]}
              fontColors={["#212121", "#212121"]}
              legends={[
                t("dashboard.coach.individual"),
                getCoachName(compareValue),
              ]}
              maxValue={metricsValue.max_value}
              data={metricsValue.top_skills_improve}
            />
          </Grid>
        ) : (
          <div>{t("dashboard.noDataYet")}</div>
        )}
      </div>

      <div className={styles.row}>
        <Grid>
          {sessionTypeMetrics ? (
            <BarChart
              title={`${t("dashboard.coach.typeOfSession")} <span>${t(
                "dashboard.coach.comparedTo"
              )}  <b>${getCoachName(compareValue)}</b></span>`}
              colors={["#4E2EE6", "#D0C2F7"]}
              fontColors={["#212121", "#000"]}
              legends={[
                t("dashboard.coach.individual"),
                getCoachName(compareValue),
              ]}
              data={sessionTypeMetrics.sessions_type}
              maxValue={sessionTypeMetrics.max_value}
              labelX={t("dashboard.coach.subjects")}
              labelY={t("dashboard.coach.session")}
              variant="left"
              hasFilter
            />
          ) : (
            <div>{t("dashboard.noDataYet")}</div>
          )}
          {barChartStackedData ? (
            <BarChartStacked
              title={t("dashboard.coach.sessionDuration")}
              colors={["#0A859A", "#17AECD", "#2FC8E6", "#83DFF3"]}
              fontColors={["#fff", "#fff", "#111", "#111"]}
              legends={[
                t("dashboard.coach.plan"),
                t("dashboard.coach.do"),
                t("dashboard.coach.check"),
                t("dashboard.coach.act"),
              ]}
              data={barChartStackedData}
              showTotal
              totalSuffix="mins"
              labelX={t("dashboard.coach.length")}
              labelY={t("dashboard.coach.minutes")}
            />
          ) : (
            <div>{t("dashboard.noDataYet")}</div>
          )}
        </Grid>
      </div>
    </div>
  );
};

export default TeamDashboard;